import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import EmbedForm from './EmbedForm'
import { APP_URL } from 'helpers'

// TODO: probably wanna use the HubSpot form for this instead of embedding the Anvil form

// The trailing slash allows local rendering of the app.useanvil.com form.
const CONTACT_SUPPORT_URL = `${APP_URL}/embed/contact-support/`

const FORM_HEIGHT = 413 // prevent page jumping
const DEFAULT_NAME = 'contact-support'
const FORM_SUCCESS_EVENT = 'contact-form-success'

export default function ContactSupportForm ({ name, onSuccess, ...others }) {
  useEffect(() => {
    if (!onSuccess) {
      return
    }
    window.addEventListener('message', (event) => {
      if (
        event.origin === process.env.APP_URL &&
        event.data === FORM_SUCCESS_EVENT
      ) {
        return onSuccess()
      }
    })
    return () => window.removeEventListener('message', onSuccess)
  }, [onSuccess])

  return (
    <EmbedForm
      name={name}
      src={CONTACT_SUPPORT_URL}
      minHeight={FORM_HEIGHT}
      title="Contact support"
      loading="lazy"
      onSuccess={onSuccess}
      {...others}
    />
  )
}

ContactSupportForm.defaultProps = {
  minHeight: FORM_HEIGHT,
  name: DEFAULT_NAME,
  signupType: null,
}

ContactSupportForm.propTypes = {
  name: PropTypes.string,
  signupType: PropTypes.string, // append onto the end of the URL
  minHeight: PropTypes.number.isRequired,
  onSuccess: PropTypes.func.isRequired,
}
